export default {
  Dashboard: {
    Title: 'Tổng quan',
    ListClass: 'Danh sách lớp',
    Achievement: 'Thành tích',
    Submited: 'Đã nộp {progress} bài',
    Correct: 'Làm đúng {correct} câu',
    SubmitProgress: 'Tiến độ',
    Watch: 'Xem ngay',
    More: 'Xem thêm',
    ClassDetail: 'Chi tiết lớp: {ClassName}',
    StudentOverview: 'Tổng quan học sinh',
    ExerciseOverview: 'Tổng quan bài tập',
    TopicOverview: 'Tổng quan chủ đề',
    ExerciseName: 'Bài tập',
    RatingSubmit: 'Tỉ lệ nộp bài',
    RatingSubmitOnTime: 'Tỉ lệ nộp bài đúng hạn',
    RatingSuccess: 'Tỉ lệ làm đúng',
    TotalSelectAnswer: 'Số lượng câu trắc nghiệm',
    ChoiceQuestion: 'Trắc nghiệm',
    TotalQuestion: 'Tổng số câu',
    Topic: 'Chủ đề',
    TotalExercise: 'Số bài đã giao',
    TotalSuccessAnswer: 'Số câu làm đúng',
    TotalSubmit: 'Số bài đã nộp',
    TotalSubmitMedium: 'Tỉ lệ nộp bài trung bình',
    SummaryStudent: 'Tổng {total} học sinh',
    SummaryExercise: 'Tổng {total} bài tập',
    SummaryTopic: 'Tổng {total} chủ đề',
    TitleRanking: 'Tổng quan tình hình giao - nộp bài',
    Submitted: 'đã nộp',
    Student: 'Học sinh',
    RatingSubmitAverage: 'Tỉ lệ nộp bài trung bình',
    RatingSuccessAverage: 'Tỉ lệ làm đúng trung bình',
    SubmitedRating: 'Đã nộp',
    NotSubmitedRating: 'Chưa nộp',
    CorrectRating: 'Đúng',
    FalseRating: 'Sai',
    NotDoneRating: 'Chưa làm',
    DiarySearch: 'Nhập từ khóa để tìm kiếm',
    Ranking: 'Xếp theo thứ hạng',
    StudentName: 'Xếp theo tên học sinh',
    SubmitRateAsc: 'Tỉ lệ nộp bài tăng dần',
    SubmitRateDesc: 'Tỉ lệ nộp bài giảm dần',
    CorrectRateAsc: 'Tỉ lệ đúng tăng dần',
    CorrectRateDesc: 'Tỉ lệ đúng giảm dần',
    SortWeek: 'Xếp theo tuần',
    Program: 'Xếp theo phân phối chương trình',
    NumberExerciseAsc: 'Số bài giao tăng dần',
    NumberExerciseDesc: 'Số bài giao giảm dần',
    SubmitExercise: 'Số bài tập đã nộp',
    AssignmentExercise: 'Số bài tập đã giao',
    SubmitRate: 'Tỉ lệ nộp bài',
    ExerciseExpired: 'Bài tập đã hết hạn gần đây',
    EmptyClass: 'Chưa có lớp học',
    DescriptionEmptyClass: 'Vui lòng tạo lớp học để có dữ liệu <b>Tổng quan</b>',
    SameRank: 'Đồng hạng',
    TitleCol: 'Giao: exercise bài, tỷ lệ nộp: percent%',
    FeatureReputation: 'Tính năng thường dùng',
    ComposeExercise: 'Soạn bài',
    GiveExercise: 'Giao bài',
    RefreshData: 'Lấy dữ liệu mới nhất',
    FormalClassroom: 'Lớp học chính quy',
    AddClassroom: 'Lớp học thêm',
    AddInformation: 'Bổ sung thông tin',
    ChangeStyle: 'Đổi kiểu soạn',
    AddNewQuestion: 'Thêm câu hỏi mới',
    Refer: 'Tham khảo',
    SetUpInformation: 'Thiết lập thêm thông tin cho phiếu bài tập: tên bài tập, chủ đề,...',
    ChoseNewQuestion: 'Chọn soạn mới từng câu hỏi hoặc tải lên file bài tập có sẵn',
    AddWorksheets: 'Tạo phiếu bài tập đa dạng với nhiều loại câu hỏi khác nhau',
    UseQuestion: 'Sử dụng câu hỏi có sẵn, tiết kiệm thời gian soạn phiếu bài tập'

  }
}
